import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from "../../../ApiService";
import {IRootState} from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import SchoolScheduleList from "../../../SchoolScheduleList";
import School from "../../../../models/School";
import LoadingPage from "../../../LoadingPage";
import SchoolList from "../../../SchoolList";
import AdminSchoolMenu from "../../../AdminSchoolMenu";
import SchoolPageTitle from '../../../SchoolPageTitle';

interface SchoolWorkloadSchedulesPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
}

interface SchoolWorkloadSchedulesPageState {
    school?: School; 
}

class SchoolWorkloadSchedulesPage extends Component<SchoolWorkloadSchedulesPageProps & DispatchProps, SchoolWorkloadSchedulesPageState> {
    static displayName = SchoolWorkloadSchedulesPage.name;

    constructor(props: SchoolWorkloadSchedulesPageProps & DispatchProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
        
        const school = await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
        
        this.setState({
            school: school
        })
    }

    async componentDidUpdate(prevProps: Readonly<SchoolWorkloadSchedulesPageProps & DispatchProps>, prevState: any): Promise<void> {

    }

    render() {
        
        if(this.state.school === undefined)
        {
            return <LoadingPage/>
        }
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Schedules"/> 
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode}/>
                <SchoolList title={this.state.school.schoolName!} enableRowLinks={false} schools={[this.state.school]} loading={false}>
                </SchoolList>  
                <SchoolScheduleList apiService={this.props.apiService} school={this.state.school} />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {match: any}): SchoolWorkloadSchedulesPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            
            apiService: state.auth.apiService
        };
    }
)(SchoolWorkloadSchedulesPage)